import { render, staticRenderFns } from "./BrankProduct.vue?vue&type=template&id=6a10b1a2&"
import script from "./BrankProduct.vue?vue&type=script&lang=js&"
export * from "./BrankProduct.vue?vue&type=script&lang=js&"
import style0 from "./BrankProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports